import { createStrictContext as e } from "../../util/context/createStrictContext.js";
import { jsx as n } from "react/jsx-runtime";
const [i, C] = e("Config"), s = (o) => {
  const {
    children: t,
    config: r
  } = o;
  return /* @__PURE__ */ n(i, {
    value: {
      config: r
    },
    children: t
  });
};
export {
  s as ConfigProvider,
  C as useConfigContext
};
//# sourceMappingURL=ConfigContext.js.map
